import { getLanguageFromStorage, triggerAnalyticsEvent } from 'syf-js-utilities';
import { DEFAULTS } from '../const/analytics';
var triggerAnalytics = function (_a) {
    var _b = _a.pageFunction, pageFunction = _b === void 0 ? DEFAULTS.PAGE_FUNCTION : _b, _c = _a.pageKind, pageKind = _c === void 0 ? DEFAULTS.PAGE_KIND : _c, _d = _a.pageName, pageName = _d === void 0 ? DEFAULTS.PAGE_NAME : _d, _e = _a.product, product = _e === void 0 ? DEFAULTS.PRODUCT : _e, _f = _a.pageSubFunction, pageSubFunction = _f === void 0 ? DEFAULTS.SUB_FUNCTION : _f, _g = _a.message, message = _g === void 0 ? DEFAULTS.MESSAGE : _g, _h = _a.errorMessage, errorMessage = _h === void 0 ? DEFAULTS.ERROR_MESSAGE : _h, _j = _a.messageType, messageType = _j === void 0 ? errorMessage : _j, _k = _a.clientName, clientName = _k === void 0 ? DEFAULTS.CLIENT_NAME : _k;
    triggerAnalyticsEvent({
        pageFunction: pageFunction,
        messageType: messageType,
        errorMessage: errorMessage,
        message: message,
        token: '',
        pageName: pageName,
        pageSubFunction: pageSubFunction,
        countryLanguage: "us|".concat(getLanguageFromStorage()),
        clientName: clientName,
        customerType: DEFAULTS.CUSTOMER_TYPE,
        pageKind: pageKind,
        product: product
    });
};
export default triggerAnalytics;
